import { createAxiosCreverseFetcher } from '@mathflat/creverse-auth/axios-fetcher'

import maxios from '@/utils/axios/maxios'

export const creverseFetcher = createAxiosCreverseFetcher(maxios)
